import { NotFoundError, NotOnboardedError } from '~/errors/errors';
import { companyGateway } from '~/gateways/companyGateway';
import { getCurrentHostName } from '~/utils/host';
import { UseCase } from '../framework/useCase';
import { MainAppState, mainAppState } from '../state/mainAppState';

export abstract class MagicUseCase extends UseCase<MainAppState> {
  protected isAppStateInitialized = () => {
    return !!(this.getState() && this.getState()?.user.companyInfo);
  };

  protected async initializeState(): Promise<MainAppState> {
    try {
      const domain = getCurrentHostName();
      mainAppState.user.companyInfo = await companyGateway.getCompanyInfo(domain);
    } catch (error: any) {
      if (error instanceof NotFoundError) {
        throw new NotOnboardedError();
      }
    }
    return mainAppState;
  }
}
